module.exports = __webpack_public_path__ + "img/law2m-m@2.1bacc86b.webp";